import React from 'react';
import { PhoneCall } from 'lucide-react';
import WhatsAppIcon from './icons/WhatsAppIcon';

const FloatingSupport = () => {
  const phoneNumber = '+919849231222';
  const whatsappUrl = `https://wa.me/${phoneNumber.replace(/\s+/g, '')}`;
  const callUrl = `tel:${phoneNumber.replace(/\s+/g, '')}`;

  return (
    <div className="fixed right-6 top-1/2 -translate-y-1/2 z-50 flex flex-col gap-4">
      {/* WhatsApp Button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="group relative flex items-center justify-center w-14 h-14 bg-green-500 text-white rounded-full shadow-lg hover:bg-green-600 transition-all duration-300 hover:scale-110"
        title="WhatsApp Support"
      >
  <WhatsAppIcon size={28} className="text-white" />
        <span className="absolute right-full mr-4 px-3 py-1 bg-white text-slate-900 text-sm font-medium rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap shadow-md pointer-events-none">
          WhatsApp Us
        </span>
      </a>

      {/* Call Button */}
      <a
        href={callUrl}
        className="group relative flex items-center justify-center w-14 h-14 bg-blue-600 text-white rounded-full shadow-lg hover:bg-blue-700 transition-all duration-300 hover:scale-110"
        title="Call Support"
      >
        <PhoneCall size={24} />
        <span className="absolute right-full mr-4 px-3 py-1 bg-white text-slate-900 text-sm font-medium rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap shadow-md pointer-events-none">
          Call Us
        </span>
      </a>
    </div>
  );
};

export default FloatingSupport;
